import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "photosFilled"
const PhotosFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.875 6.375C20.703 6.375 21.375 7.047 21.375 7.875V19.875C21.375 20.703 20.703 21.375 19.875 21.375H7.875C7.047 21.375 6.375 20.703 6.375 19.875V7.875C6.375 7.047 7.047 6.375 7.875 6.375zM7.875 19.875H17.503Q17.487 19.807 17.466 19.735C17.303 19.165 16.975 18.397 16.31 17.632 15.114 16.26 12.72 14.775 7.875 14.636zM19.875 16.205C19.268 16.333 18.742 16.6 18.325 16.88 18.155 16.994 18.008 17.107 17.885 17.21 18.431 17.98 18.737 18.727 18.908 19.323Q18.995 19.628 19.04 19.875H19.875zM16.125 9.375C14.882 9.375 13.875 10.382 13.875 11.625S14.882 13.875 16.125 13.875 18.375 12.868 18.375 11.625 17.368 9.375 16.125 9.375"
            clipRule="evenodd"
          />
          <path d="M16.5 3C17.328 3 18 3.672 18 4.5V4.875H7.875C6.218 4.875 4.875 6.218 4.875 7.875V18H4.5C3.672 18 3 17.328 3 16.5V4.5C3 3.672 3.672 3 4.5 3z" />
        </svg>
      }
    </span>
  )
}
export default PhotosFilledIcon
